// src/icons/Monitor.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Monitor({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.89258 16.2514H7.99972M11.1069 16.2514H7.99972M7.99972 13.959V16.2514",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M3.5 8H5L7 10L9 5L11 7H12.5",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "0.75",
            y: "1.74854",
            width: "14.5",
            height: "11.193",
            rx: "2",
            stroke: "currentColor",
            strokeWidth
          }
        )
      ]
    }
  );
}

export {
  Monitor
};
